/*
  Play to win. A tab on the right of the shop opens a panel with Enter the Pitch. The game tells
  us how a run ends ("vortex-game" events); a try wins, and the email form appears. The email signs
  them up as a Shopify customer who accepts marketing, then the code shows and is applied to the
  cart. The game runs inside a shadow root so its styles stay out of the shop.
*/
(() => {
  const root = document.querySelector('[data-ptw]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const code = root.dataset.code || '';
  const WON = 'vx_ptw_won_v1';
  const SHUT = 'vx_ptw_closed_v1';
  const store = (k, v) => { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { /* blocked */ } return null; };
  const session = (k, v) => { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { /* blocked */ } return null; };

  const tab = $('[data-ptw-open]');
  const panel = $('[data-ptw-panel]');
  const show = (el, on) => { el.hidden = !on; };

  // the tab slides in after a moment, unless they closed it this visit
  if (session(SHUT) !== '1') {
    setTimeout(() => { tab.hidden = false; requestAnimationFrame(() => tab.classList.add('is-in')); }, Number(root.dataset.delay || 0) * 1000);
  }
  // already won: go straight to the code
  const won = store(WON);
  if (won) showCode(won);

  let game = null;
  let loading = null;
  const loadGame = () => {
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      if (window.VortexGame) { resolve(); return; }
      window.VORTEX_MODEL_BASE = root.dataset.models;
      window.VORTEX_GAME_EMBED = true;
      // the game's fonts have to load at page level: font rules inside a shadow root are ignored
      const fonts = document.createElement('link');
      fonts.rel = 'stylesheet';
      fonts.href = 'https://fonts.googleapis.com/css2?family=Anton&family=Great+Vibes&family=IBM+Plex+Mono:wght@500&display=swap';
      document.head.appendChild(fonts);
      const s = document.createElement('script');
      s.type = 'module';
      s.src = root.dataset.js;
      s.onerror = () => reject(new Error('The game could not load.'));
      window.addEventListener('vortex-game-ready', () => resolve(), { once: true });
      document.head.appendChild(s);
    });
    return loading;
  };

  const start = async () => {
    show($('[data-ptw-intro]'), false);
    show($('[data-ptw-loading]'), true);
    try {
      const [css] = await Promise.all([fetch(root.dataset.css).then((r) => r.text()), loadGame()]);
      const host = $('[data-ptw-game]');
      const shadow = host.shadowRoot || host.attachShadow({ mode: 'open' });
      shadow.innerHTML = `<style>${css}\n:host{display:block}</style><div class="ptw-mount"></div>`;
      show(host, true);
      game = window.VortexGame.mount(shadow.querySelector('.ptw-mount'));
    } catch (err) {
      $('[data-ptw-loading]').textContent = 'The game didn’t load. Refresh to try again.';
      return;
    }
    show($('[data-ptw-loading]'), false);
  };
  const stop = () => { if (game) { game.unmount(); game = null; } show($('[data-ptw-game]'), false); };

  const open = () => {
    show(panel, true);
    requestAnimationFrame(() => panel.classList.add('is-open'));
    tab.classList.remove('is-in');
    document.documentElement.classList.add('ptw-lock');
  };
  const close = () => {
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('ptw-lock');
    setTimeout(() => { show(panel, false); stop(); show($('[data-ptw-intro]'), !store(WON) && $('[data-ptw-win]').hidden); }, 300);
    session(SHUT, '1');
  };
  tab.addEventListener('click', open);
  $('[data-ptw-close]').addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) close(); });
  $('[data-ptw-play]').addEventListener('click', start);

  // the game says how a run ended
  window.addEventListener('vortex-game', (e) => {
    if (panel.hidden || !e.detail || e.detail.result !== 'won' || store(WON)) return;
    // let the try celebration play, then ask for the email
    setTimeout(() => {
      stop();
      show($('[data-ptw-win]'), true);
      $('[data-ptw-email]').focus();
    }, 2600);
  });

  $('[data-ptw-form]').addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = $('[data-ptw-email]').value.trim();
    const err = $('[data-ptw-error]');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      err.textContent = 'Add an email we can send your code to.';
      err.hidden = false;
      return;
    }
    err.hidden = true;
    // a Shopify customer who accepts marketing, tagged so you can see where they came from
    try {
      const fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter, play-to-win');
      await fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' });
      if (window.vortexForms) window.vortexForms.send('Play to win (10% off)', { email, code, result: 'Scored a try' });
    } catch (e2) { /* still give them the code */ }
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('vortex_play_to_win', { email_captured: true });
    } catch (e3) { /* optional */ }
    store(WON, code);
    showCode(code);
    // put the code on the cart straight away
    fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
  });

  function showCode(c) {
    show($('[data-ptw-intro]'), false);
    show($('[data-ptw-win]'), false);
    show($('[data-ptw-code]'), true);
    $('[data-ptw-code-text]').textContent = c;
    $('[data-ptw-apply]').href = `/discount/${encodeURIComponent(c)}?redirect=${encodeURIComponent(window.location.pathname)}`;
    tab.querySelector('.ptw__tab-big').textContent = 'Your 10% code';
    tab.querySelector('.ptw__tab-small').textContent = c;
  }
  $('[data-ptw-copy]').addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(code); $('[data-ptw-code-text]').textContent = 'Copied'; setTimeout(() => { $('[data-ptw-code-text]').textContent = code; }, 1200); } catch (e) { /* no clipboard */ }
  });
})();
